import {
	listPaketDeposit,
	listPaketDepositOwner,
	listTransaksiDeposit,
	listTopupDeposit,
	infoTopupDeposit,
	detailTopupDeposit,
	pagination,
	searchTopup
} from "./state"

const mutations = {
	// data
	setListPaketDeposit: (state, res) => {
		if (state.listPaketDeposit.data !== undefined) {
			state.listPaketDeposit.data.list_paket_deposit = [
				...state.listPaketDeposit.data.list_paket_deposit, ...res.data.list_paket_deposit
			];
		} else {
			state.listPaketDeposit = res
		}
	},
	setListPaketDepositOwner: (state, res) => {
		state.listPaketDepositOwner = res
	},
	setListTransaksiDeposit: (state, res) => {
		if (state.listTransaksiDeposit.data !== undefined) {
			state.listTransaksiDeposit.data.list_transaksi_deposit = [
				...state.listTransaksiDeposit.data.list_transaksi_deposit, ...res.data.list_transaksi_deposit
			];
		} else {
			state.listTransaksiDeposit = res
		}
	},
	setListTopupDeposit: (state, res) => {
		if (state.listTopupDeposit.data !== undefined) {
			state.listTopupDeposit.data = [
				...state.listTopupDeposit.data, ...res.data
			]
		} else {
			state.listTopupDeposit = res
		}
	},
	setInfoTopupDeposit: (state, res) => {
		state.infoTopupDeposit = res
	},
	setDetailTopupDeposit: (state, res) => {
		state.detailTopupDeposit = res
	},
	resetListPaketDeposit: (state) => {
		state.listPaketDeposit = listPaketDeposit()
	},
	resetListPaketDepositOwner: (state) => {
		state.listPaketDepositOwner = listPaketDepositOwner()
	},
	resetListTransaksiDeposit: (state) => {
		state.listTransaksiDeposit = listTransaksiDeposit()
	},
	resetListTopupDeposit: (state) => {
		state.listTopupDeposit = listTopupDeposit()
	},
	resetInfoTopupDeposit: (state) => {
		state.infoTopupDeposit = infoTopupDeposit()
	},
	resetDetailTopupDeposit: (state) => {
		state.detailTopupDeposit = detailTopupDeposit()
	},

	// pagination
	setNextPagination: (state, payload) => {
		state.pagination.length = payload.data.length
		state.pagination.pageNumber++
		state.pagination.offset = state.pagination.pageNumber * state.pagination.limit
	},
	resetPagination: (state, e) => {
		state.pagination = pagination()
	},

	// search
	setSearchTopup: (state, key) => {
		state.searchTopup.key = key
	},
	resetSearchTopup: (state) => {
		state.searchTopup = searchTopup()
	},
	setIsSearchTopup: (state, bool) => {
		state.isSearchTopup = bool
	},

	setScrollPosition: (state, positionY) => {
		state.scrollPosition = positionY - 100
	}
}

export default mutations